import React from 'react';
import DoctorsDetailsCard from './DoctorsDetailsCard';

const DoctorDetails = () => {
    return (
        <div>
            <DoctorsDetailsCard/>
        </div>
    );
};

export default DoctorDetails;